import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { editCustomerInfo, getCustomerInfo } from '../store/api/CustomerApi';
import { getAllProvinces, getCityList, getZoneList } from '../store/api/LocationAPI';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner';

const Profile = (props) => {

    const dispatch = useDispatch();
    const [isProvinceLoaded, setProvinceList] = useState(false);
    const isLoadingSaved = useSelector(state => state.loading?.isLoading);
    const { register, handleSubmit, errors } = useForm();
    const { provinceList, cityList, zoneList, currentLocation } = useSelector(state => { return { provinceList: state.locationDataReducer.provinceList, cityList: state.locationDataReducer.cityList, zoneList: state.locationDataReducer.zoneList, currentLocation: state.locationDataReducer.currentLocation } })
    const { currentCustomer } = useSelector(state => { return { currentCustomer: state.customerDataReducer.currentCustomer } });
    const loadCityList = (provinceID) => {
        dispatch(getCityList(provinceID))
    }
    const loadZoneList = (cityID) => {
        dispatch(getZoneList(cityID));
    }
    useEffect( () => {
        dispatch(getAllProvinces());
        dispatch(getCustomerInfo());
    },[]);
    useEffect( () => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, []);    
    const checkNationalCode = (NationalCode) => {
        if (NationalCode.length === 10) {
            if (NationalCode === '1111111111' ||
            NationalCode === '0000000000' ||
            NationalCode === '2222222222' ||
            NationalCode === '3333333333' ||
            NationalCode === '4444444444' ||
            NationalCode === '5555555555' ||
            NationalCode === '6666666666' ||
            NationalCode === '7777777777' ||
            NationalCode === '8888888888' ||
            NationalCode === '9999999999') {
                    return false;
            }
            let c = parseInt(NationalCode.charAt(9));
            let n = parseInt(NationalCode.charAt(0)) * 10 +
                parseInt(NationalCode.charAt(1)) * 9 +
                parseInt(NationalCode.charAt(2)) * 8 +
                parseInt(NationalCode.charAt(3)) * 7 +
                parseInt(NationalCode.charAt(4)) * 6 +
                parseInt(NationalCode.charAt(5)) * 5 +
                parseInt(NationalCode.charAt(6)) * 4 +
                parseInt(NationalCode.charAt(7)) * 3 +
                parseInt(NationalCode.charAt(8)) * 2;
            let r = n - parseInt(n / 11) * 11;
            if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) 
            {
                return false;
            } 
            else 
            {
                return true;
            }
        } 
        else 
        {
           return false;
        }        

    }    
    const provinceOnClick = () => {
        if (isProvinceLoaded)
            return;
        setProvinceList(true);

    }
    const history = useHistory();
    const onSubmit = (data) => {
        if (currentLocation) {
            if (currentLocation.lat && currentLocation.lat !== "")
                data.Latitude = currentLocation.lat;
            if (currentLocation.lng && currentLocation.lng !== "")
                data.Longtitude = currentLocation.lng;
        }
        dispatch(editCustomerInfo(data, () => {
            history.push("/Services");
        }))
    }

    return (
        <div className="container-fluid mt-1">
            <br />
            {!currentCustomer && <Loader
                type="BallTriangle" color="#bb1370"
                height={50}
                width={50}
            />}
            {currentCustomer &&
                <div className="card">
                    <div className="card-header headerStyle">پروفایل کاربری</div>
                    <div className="card-body bodyStyle">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <input ref={register()} name="CustomerId" type="hidden" />
                            <div style={{ position: 'relative' }} className="form-group">
                                <label> کد ملی </label>
                                <input className="form-control" name="NationalCode" type="text" ref={register({ required: true, validate : checkNationalCode })} defaultValue={currentCustomer.NationalCode} />
                                {errors.NationalCode && <small className="errors"> کد ملی را وارد کنید </small>}
                            </div>

                            <div className="form-group">
                                <label>جنسیت</label>
                                <select className="form-control" name="Type" ref={register({ required: true })} defaultValue={currentCustomer.Type}>
                                    <option value=""> لطفا انتخاب کنید </option>
                                    <option value="مرد"> مرد </option>
                                    <option value="زن"> زن </option>
                                </select>
                                {errors.Type && <small className="errors"> جنسیت را وارد کنید </small>}
                            </div>

                            <div className="form-group">
                                <label> نام </label>
                                <input className="form-control" name="Name" ref={register({ required: true })} type="text" defaultValue={currentCustomer.Name} />
                                {errors.Name && <small className="errors"> نام اجباری است </small>}
                            </div>

                            <div className="form-group">
                                <label> موبایل </label>
                                <input className="form-control" name="Mobile" ref={register({ required: true })} type="text" defaultValue={currentCustomer.Mobile} />
                                {errors.Mobile && <small className="errors"> موبایل اجباری است </small>}
                            </div>
                            <div className="form-group">
                                <label> تلفن </label>
                                <input className="form-control" name="Phone" ref={register()} type="text" defaultValue={currentCustomer.Phone} />
                            </div>
                            <div className="form-group">
                                <label> ایمیل </label>
                                <input className="form-control" name="Email" ref={register()} type="text" defaultValue={currentCustomer.Email} />
                            </div>
                            <div className="form-group">
                                <label>نام استان</label>
                                {!isProvinceLoaded &&
                                    <select className="form-control" name="ProvinceID" onClick={e => provinceOnClick()} ref={register({ required: true })} value={currentCustomer.ProvinceID}>
                                        <option value={currentCustomer.ProvinceID}>{currentCustomer.ProvinceName}</option>
                                    </select>
                                }
                                {isProvinceLoaded &&
                                    <select className="form-control" name="ProvinceID" onChange={e => loadCityList(e.target.value)} ref={register({ required: true })} >
                                        <option value="">انتخاب کنید</option>
                                        {isProvinceLoaded && provinceList && Array.isArray(provinceList) && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                    </select>
                                }
                                {errors.ProvinceID && <small className="errors">نام استان اجباری است</small>}

                            </div>
                            <div className="form-group">
                                <label>نام شهر</label>
                                {!isProvinceLoaded &&
                                    <select className="form-control" name="CityID" ref={register({ required: true })} value={currentCustomer.CityID}>
                                        <option value={currentCustomer.CityID}>{currentCustomer.CityName}</option>
                                    </select>
                                }
                                {isProvinceLoaded &&
                                    <select className="form-control" name="CityID" onChange={e => loadZoneList(e.target.value)} ref={register({ required: true })} >
                                        <option value="">انتخاب کنید</option>
                                        {cityList && Array.isArray(cityList) && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                    </select>
                                }
                                {errors.CityID && <small className="errors">نام شهر اجباری است</small>}
                            </div>
                            <div className="form-group">
                                <label>نام منطقه</label>
                                {!isProvinceLoaded &&
                                    <select className="form-control" name="ZoneID" ref={register({ required: true })} value={currentCustomer.ZoneID}>
                                        <option value={currentCustomer.ZoneID}>{currentCustomer.ZoneName}</option>
                                    </select>
                                }
                                {isProvinceLoaded &&
                                    <select className="form-control" name="ZoneID" ref={register({ required: true })}>
                                        <option value="">انتخاب کنید</option>
                                        {zoneList && Array.isArray(zoneList) && zoneList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                    </select>
                                }
                                {errors.ZoneID && <small className="errors">منطقه جفرافیایی اجباری است</small>}
                            </div>
                            <div className="form-group">
                                <label> آدرس </label>
                                <input className="form-control" name="Address" ref={register({ required: true })} type="text" defaultValue={currentCustomer.Address} />
                                {errors.Address && <small className="errors"> آدرس اجباری است </small>}
                            </div>
                            {!isLoadingSaved ? <button className="btn btn-primary btn-block w-100 mt-2">  ثبت اطلاعات  </button> : <span> لطفا کمی صبر کنید <Loader type="BallTriangle" color="#bb1370" height={20} width={20} /> </span>}
                        </form>
                    </div>
                </div>
            }

        </div>
    )
}
export default Profile;
